(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["livenani-challenge"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var chip = e.target.closest('.livenani-chip');
  if (!chip) return;
  var note = document.getElementById('livenani-note');
  if (!note) return;
  var prompt = chip.getAttribute('data-prompt') || '';
  var cur = note.value.replace(/\s+$/, '');
  note.value = (cur ? cur + '\n\n' : '') + prompt + ' ';
  note.focus();
  note.selectionStart = note.selectionEnd = note.value.length;
});

/* On submit: prevent the native form (there is no Shopify contact form, so
   nothing emails the store inbox / opens a Gladly conversation), subscribe to
   the Klaviyo list + write profile props, fire the note-capture metric, then
   reveal the confirmation in place. Config is read from data-* on #livenani-form
   because this script is a shared static asset and can't read Liquid directly. */
document.addEventListener('submit', function (e) {
  var form = e.target.closest('#livenani-contact-form');
  if (!form) return;
  e.preventDefault();

  var cfg = form.closest('[data-klaviyo-company]');
  var company = cfg && cfg.getAttribute('data-klaviyo-company');

  var val = function (sel) { var el = form.querySelector(sel); return el ? el.value.trim() : ''; };
  var email = val('[name="contact[email]"]');
  var name = val('[name="contact[First name]"]');
  var noteText = val('#livenani-note');
  var sendBack = val('[name="contact[Send back on]"]');

  /* Swap the form view for the confirmation (both are pre-rendered in the DOM). */
  var reveal = function () {
    cfg.querySelectorAll('[data-livenani-view="form"]').forEach(function (el) { el.hidden = true; });
    var thanks = cfg.querySelector('[data-livenani-view="thanks"]');
    if (thanks) {
      thanks.hidden = false;
      thanks.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  /* Not configured / no email: still confirm so the visitor isn't dead-ended. */
  if (!company || !email) { reveal(); return; }

  var listId = cfg.getAttribute('data-klaviyo-list') || '';
  var metric = cfg.getAttribute('data-klaviyo-metric') || 'Wrote LIVENANI Note';

  var REV = '2025-07-15';
  var post = function (path, payload) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', revision: REV },
      body: JSON.stringify(payload)
    }).catch(function () {});
  };

  /* 1) Subscribe to the list + persist custom profile properties (the client
        events endpoint does NOT write profile props, so they ride this call). */
  if (listId) {
    post('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: '#LIVENANI Challenge',
          profile: { data: { type: 'profile', attributes: {
            email: email,
            first_name: name,
            /* Custom profile properties are persisted via THIS (subscriptions)
               call — the client events endpoint does not write profile props.
               These power future campaigns/segments (e.g. "Send Back On in the
               next 7 days"); the event keeps the immutable per-submission copy. */
            properties: {
              'LIVENANI Note': noteText,
              'LIVENANI Send Back On': sendBack,
              'LIVENANI Participant': true
            },
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    });
  }

  /* 2) Fire the metric carrying the note + send-back date as event properties */
  post('events', {
    data: {
      type: 'event',
      attributes: {
        metric: { data: { type: 'metric', attributes: { name: metric } } },
        profile: { data: { type: 'profile', attributes: { email: email, first_name: name } } },
        properties: {
          'Note to Future Me': noteText,
          'Send back on': sendBack,
          'Campaign': '#LIVENANI Challenge'
        }
      }
    }
  });

  reveal();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
